import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows, differenceStats } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { StatNumber } from './StatNumber';
export function Difference() {
  return <section className="w-full bg-bone px-5 py-20 sm:py-28" data-id="element-48" data-mp="58z49v7m0e9k">
      <div className="mx-auto max-w-6xl" data-id="element-49" data-mp="57ec2c8rp7ev">
        <SectionHeading eyebrow="La differenza del Kit" title={<>
              Da docente esausto a{' '}
              <span className="text-brand" data-id="element-51" data-mp="3rgpay8k1tpkd">riferimento indiscusso</span>
            </>} subtitle="Dai alle tue lezioni una struttura professionale, ai tuoi studenti la voglia di parlare inglese e a te stesso il tempo di goderti di nuovo la docenza." data-id="element-50" data-mp="3mhm6oqbw7ndg" />

        <Reveal delay={0.06} data-id="element-52" data-mp="3ihv5dsoqpouo">
          <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-1 overflow-hidden rounded-2xl border-2 border-ink bg-white sm:grid-cols-3" data-id="element-53" data-mp="1bpkm724vv72e">
            {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-8 text-center ${index > 0 ? 'border-t-2 border-ink sm:border-l-2 sm:border-t-0' : ''}`} data-id="element-54" data-mp="1gm1msvt9rdwd" data-mpi={index}>
                <dt className="sr-only" data-id="element-55" data-mp="1f8iqlw5ep2a0">{stat.label}</dt>
                <dd data-id="element-56" data-mp="1f7r378lyqaut">
                  <StatNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} className="block font-display text-5xl leading-none text-brand" data-id="element-57" data-mp="1t1i4jtpjiofg" />
                  <span className="mx-auto mt-4 block max-w-[14rem] text-sm font-semibold leading-snug text-ink/70" data-id="element-58" data-mp="1o2nkypjr0vua">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.08} data-id="element-59" data-mp="1ab0g41bqqezw">
          <h3 className="mt-20 text-center font-display text-2xl leading-tight text-ink sm:text-4xl" data-id="element-60" data-mp="1aba63owscm5l">
            Il costo di improvvisare <span className="text-ink/35" data-id="element-61" data-mp="15dh2n3mva690">vs.</span>{' '}
            <span className="text-brand" data-id="element-62" data-mp="2lol2ajme6v4n">il sistema definitivo</span>
          </h3>
        </Reveal>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-lift" data-id="element-63" data-mp="2gphw2vuoeiv3">
          <div className="grid grid-cols-1 border-b-2 border-ink md:grid-cols-2" data-id="element-64" data-mp="2oq7fv4b318qg">
            <div className="flex items-center gap-3 bg-bone px-6 py-5 md:border-r-2 md:border-ink" data-id="element-65" data-mp="2ss2pqx72wufu">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-ink/10 text-ink/60" data-id="element-66" data-mp="2xrnpvaxzj8u5">
                <XIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-67" data-mp="32pp7drfrj03i" />
              </span>
              <span className="font-display text-lg text-ink/55" data-id="element-68" data-mp="254krcitb6y3w">
                Prima di Inglese Pronto™
              </span>
            </div>
            <div className="flex items-center gap-3 bg-ink px-6 py-5" data-id="element-69" data-mp="2a007jhesh63h">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-volt text-ink" data-id="element-70" data-mp="2f04lp0s85oqj">
                <CheckIcon className="h-4 w-4" aria-hidden="true" strokeWidth={3} data-id="element-71" data-mp="2ju8vrswsecvu" />
              </span>
              <span className="font-display text-lg text-white" data-id="element-72" data-mp="1maxp47cbz97x">
                Con il Kit Inglese Pronto™
              </span>
            </div>
          </div>

          <ul data-id="element-73" data-mp="1jr126xqsafkx">
            {comparisonRows.map((row, index) => <li key={row.beforeTitle} className={`grid grid-cols-1 md:grid-cols-2 ${index > 0 ? 'border-t-2 border-ink/10' : ''}`} data-id="element-74" data-mp="1et97xx2o2hdk" data-mpi={index}>
                <Reveal delay={index * 0.03} className="border-b border-ink/10 bg-white px-6 py-6 md:border-b-0 md:border-r-2 md:border-ink/10 md:px-8" data-id="element-75" data-mp="19t4smadhvsox">
                  <p className="font-display text-base text-ink/50" data-id="element-76" data-mp="14xfm1n325bj4">
                    {row.beforeTitle}
                  </p>
                  <p className="mt-2 text-base leading-relaxed text-ink/60" data-id="element-77" data-mp="w280slre7fix">
                    {row.beforeText}
                  </p>
                </Reveal>
                <Reveal delay={index * 0.03 + 0.03} className="bg-brand-light/40 px-6 py-6 md:px-8" data-id="element-78" data-mp="r1k8zxvcaunn">
                  <p className="font-display text-base text-brand-dark" data-id="element-79" data-mp="m2qwo8rsh9p2">
                    {row.afterTitle}
                  </p>
                  <p className="mt-2 text-base font-medium leading-relaxed text-ink/80" data-id="element-80" data-mp="d3dn7g3o0l4c">
                    {row.afterText}
                  </p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}